import { render, staticRenderFns } from "./BaseInfoButton.vue?vue&type=template&id=4908f5f3&scoped=true"
import script from "./BaseInfoButton.vue?vue&type=script&lang=js"
export * from "./BaseInfoButton.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoButton.vue?vue&type=style&index=0&id=4908f5f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4908f5f3",
  null
  
)

export default component.exports